import { useRef, useEffect } from 'react';


export const useDocumentTitle = (title: string, options: Options = defaultOptions): void => {
  const prevTitle = useRef(document.title);

  const { restoreOnUnmount } = options;

  useEffect(() => {
    if (title) {
      document.title = title;
    }

    return () => {
      if (restoreOnUnmount) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        document.title = prevTitle.current;
      }
    };
  }, [title, restoreOnUnmount]);
};

type Options = {
  restoreOnUnmount?: boolean,
}

const defaultOptions: Options = { restoreOnUnmount: true };